import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './lib/context/AuthContext';
import { AppRoutes } from './AppRoutes';
import { WindowManagerProvider } from './lib/context/WindowManagerContext';
import { WindowLayer } from './components/desktop/WindowLayer';
import { MobileWindowBar } from './components/desktop/MobileWindowBar';
import { ErrorBoundary } from './components/common/ErrorBoundary';

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <WindowManagerProvider>
          <ErrorBoundary scope="app">
            <AppRoutes />
          </ErrorBoundary>
          {/* Floating app windows — rendered above whatever route is active */}
          <ErrorBoundary scope="window layer">
            <WindowLayer />
            <MobileWindowBar />
          </ErrorBoundary>
        </WindowManagerProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
